import { Address } from "./address.js";
class ThirdPartyAddress extends Address {
  toStr() {
    return this.rawAddress;
  }
  toSortStr(address, start = 6, end = 4) {
    try {
      if (!address) {
        return "";
      }
      if (address.length <= start + end) {
        return address;
      }
      return `${address.substring(0, start)}...${address.substring(
        address.length - end,
        address.length
      )}`;
    } catch (error) {
      return "";
    }
  }
}
export {
  ThirdPartyAddress
};
//# sourceMappingURL=thirdparty-address.js.map
